import { useTranslate } from '@c3po/i18n'
import { LeftMenuSectionSubTitle, LeftMenuSectionTitle } from '@front-web/header-revamped'
import Link from '@kawaui/link'
import { useAuth } from '@narf/auth'

import { ROUTES } from 'utils/methods'

import * as Styled from './styles'

const LoggedInHeader = () => {
  const { i18n } = useTranslate()
  const member = useAuth()

  if (!member) return null

  return (
    <>
      <LeftMenuSectionTitle>{`${i18n('menu.title')} ${member.firstName}`}</LeftMenuSectionTitle>
      <LeftMenuSectionSubTitle>
        <Styled.Content>
          {i18n('menu.access')}
          <Link href={ROUTES.MY_ACCOUNT}>{i18n('menurevamp.menu-title.my-account')}</Link>
        </Styled.Content>
      </LeftMenuSectionSubTitle>
    </>
  )
}

export default LoggedInHeader
